import { observer } from 'mobx-react-lite';
import React from 'react';

import Typography from '@smart-tv/components/typography/typography';

import { rootStore } from '../_stores/store-root';

export const calculateExpiryContent = (expireTimeMiliseconds: number, short?: boolean) => {
  const expiresDate = new Date(expireTimeMiliseconds);
  const currentDate = new Date();
  const diffTime = expiresDate.getTime() - currentDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return '';
  }

  if (diffDays === 0) {
    return short ? 'I dag' : 'Udløber I dag';
  }

  const expiresFullText = short ? '' : 'Udløber om ';

  return expiresFullText + diffDays + (diffDays === 1 ? ' dag' : ' dage');
};

const SheetDescriptionInfoExpiry = observer(() => {
  const content = rootStore.sheetStore.sheet.readableExpireTime;

  if (!content) {
    return null;
  }
  return <Typography variant="caption2">{content}</Typography>;
});

export default SheetDescriptionInfoExpiry;
